import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const branchRefundsWidget: DashboardWidgetConfiguration = {
  widgetId: "branch.refunds",
  name: "Branch refunds",
  description: "Branch refunds for the selected dashboard period.",
  apps: [
    "configuration",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "finance.credit-notes",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "document_id",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Refunds",
    subtext: "in the last 30 days",
    icon: "money",
    color: "warning",
    valueFormat: "number",
    valueMultiplier: 1,
  },
  dummyData: {
    value: 0,
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
